import { createFileRoute, Outlet } from "@tanstack/react-router";
import { kennelGateRoute } from "@/features/provider-home";

export const Route = createFileRoute("/kennel")({
    ssr: kennelGateRoute.ssr,
    beforeLoad: kennelGateRoute.beforeLoad,
    component: Outlet,
});
